/**
 * Meta Pixel Utility Functions
 * Tracks user interactions for Facebook Meta Pixel
 */

// Initialize Meta Pixel (already done in index.html, but this provides a helper)
export const initMetaPixel = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    console.log('Meta Pixel initialized');
  }
};

/**
 * Track standard Meta Pixel events
 * @param {string} eventName - The event name (e.g., 'PageView', 'Lead', 'Contact')
 * @param {Object} parameters - Additional event parameters
 */
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, parameters);
      console.log(`Meta Pixel Event: ${eventName}`, parameters);
    } catch (e) {
      console.warn('Meta Pixel tracking failed:', e);
    }
  } else {
    console.warn('Meta Pixel not loaded');
  }
};

/**
 * Track custom Meta Pixel events
 * @param {string} eventName - Custom event name
 * @param {Object} parameters - Event parameters
 */
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('trackCustom', eventName, parameters);
      console.log(`Meta Pixel Custom Event: ${eventName}`, parameters);
    } catch (e) {
      console.warn('Meta Pixel custom tracking failed:', e);
    }
  } else {
    console.warn('Meta Pixel not loaded');
  }
};

/**
 * Track course registration form submission
 * @param {Object} formData - Form data
 */
export const trackCourseRegistration = (formData) => {
  trackEvent('Lead', {
    content_name: 'Course Registration',
    content_category: 'Education',
    status: 'submitted',
    value: 0, // Update with actual course value if applicable
    currency: 'USD',
    user_data: {
      email: formData.email,
      phone: formData.phone
    }
  });
};

/**
 * Track CTA button click (booking a call)
 */
export const trackCallBooking = () => {
  trackEvent('Contact', {
    content_name: 'Book Call',
    content_category: 'Consultation',
    status: 'clicked'
  });
};

/**
 * Track email link click
 */
export const trackEmailClick = () => {
  trackEvent('Contact', {
    content_name: 'Email Contact',
    content_category: 'Support',
    status: 'clicked'
  });
};

/**
 * Track page view for specific pages
 * @param {string} pageName - Name of the page
 * @param {string} pageUrl - URL of the page
 */
export const trackPageView = (pageName, pageUrl) => {
  trackEvent('PageView', {
    content_name: pageName,
    page_path: pageUrl
  });
};

/**
 * Track social media link clicks
 * @param {string} platform - Social platform name (e.g., 'Facebook', 'LinkedIn')
 */
export const trackSocialClick = (platform) => {
  trackCustomEvent('SocialClick', {
    platform: platform,
    content_category: 'Social Media'
  });
};
